export default "__VITE_ASSET__BcX9Cfaz__"